import styled from 'styled-components'
import { noop } from 'lodash'

import { breakpoints } from '@/styles'
import useSessionComplete from '@/hooks/use-session-complete'
import useSetTrrebDlv from '@/hooks/use-set-trreb-dlv'
import { ListingCardItem } from '@/features/ListingsMap/map-list/listing-card-item'
import { useListImpressionTracking } from '@/components/ImpressionProvider/useListImpressionTracking'
import {
  getClickEventId,
  getListingCardDlv
} from '@/components/listing-card/utils'
import { useTermsDialogContext } from '@/components/terms-dialog/context'

const Wrapper = styled.div`
  margin: 0 auto 100px;
`

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 320px);
  grid-gap: 20px;
  justify-content: flex-start;
  align-content: start;
  margin: auto;
  max-width: ${({ maxCol }) => {
    if (maxCol >= 3) {
      return '1096px'
    } else if (maxCol === 1) {
      return '370px'
    } else if (maxCol === 2) {
      return '740px'
    } else {
      return '1096px' // default value if prop is not provided or has invalid value
    }
  }};

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    grid-template-columns: 1fr;
  }
`

const CardList = ({ listings = [], maxCol }) => {
  const isLoggedIn = useSessionComplete()
  const { checkAgreementMismatch, isLoading } = useTermsDialogContext()
  const isAgreementMismatched = checkAgreementMismatch('trreb_agreements')
  const isLoadingAgreements = isLoading && isLoggedIn
  useListImpressionTracking({ id: 'company-page', minVisibleDuration: 0 })

  useSetTrrebDlv(isAgreementMismatched)

  return (
    <Wrapper data-impression-container="true">
      <GridWrapper maxCol={parseInt(maxCol)}>
        {listings.map(listing => {
          return (
            <ListingCardItem
              id={getClickEventId(listing, false, '')}
              key={listing.listing_id}
              listing={listing}
              hasSession={isLoggedIn}
              isAgreementMismatched={isAgreementMismatched}
              isAgreementLoading={isLoadingAgreements}
              onListingHover={noop}
              trackImpression={{
                id: listing.listing_id,
                enabled: true,
                page: 'company-page',
                section: 'listing-card',
                sponsored: false
              }}
              onClick={() => {
                window.dataLayer.push({
                  event: getClickEventId(listing, false, ''),
                  listingCard: getListingCardDlv(listing, false)
                })
              }}
            />
          )
        })}
      </GridWrapper>
    </Wrapper>
  )
}

export default CardList
